'use client';

import { type RoadMapUpdate } from '@/domain/roadmap/types';
import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { type Control, Controller } from 'react-hook-form';

import { FieldActionsWrapper } from './shared/FieldActionsWrapper';

interface SpecificationFieldProps {
  viewOnly: boolean;
  control: Control<RoadMapUpdate, unknown>;
}

export function SpecificationField({ viewOnly, control }: Readonly<SpecificationFieldProps>) {
  return (
    <Box sx={{ py: 0.75, width: '100%' }}>
      <Controller
        name="specification"
        control={control}
        render={({ field }) => (
          <FieldActionsWrapper copyValue={field.value ?? ''}>
            <TextField
              {...field}
              label="Specification"
              disabled={viewOnly}
              fullWidth
              size="small"
              slotProps={{ htmlInput: { maxLength: 500 } }}
            />
          </FieldActionsWrapper>
        )}
      />
    </Box>
  );
}
